import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import './CustomAlert.style.css';

const CustomAlert = ({
  title,
  show,
  cancelText = 'Cancel',
  okText = 'Ok',
  message,
  onCancel,
  onOkay = () => { }
}) => {

  return (
    <Modal show={show} centered >
      <Modal.Header style={{ paddingBottom: '0' }} >
        <Modal.Title className='title-style-popup' >{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ paddingBottom: '0' }}>
        <h5 style={{ fontSize: "1rem", whiteSpace: "pre-wrap" }}>{message}</h5>
      </Modal.Body>
      <Modal.Footer>
        {onCancel && (
          <Button className='btn-modal-cancel' style={{ marginRight: '12px' }} onClick={onCancel}>
            {cancelText}
          </Button>
        )}
        {onOkay && (<Button className='btn-modal-ok' style={{ background: "#1A6BE8 !important" }} onClick={onOkay}>
          {okText}
        </Button>)}
      </Modal.Footer>
    </Modal>

  );
};

export default CustomAlert;
